// Prescription reserve

import { createApp } from 'vue/dist/vue.esm-bundler'
import axios from 'axios';

const prescriptionReserve = document.querySelector('#prescriptionReserve');
if (prescriptionReserve) {
  createApp({
    data: () => ({
      success: {
        show: false,
        heading: '',
        text: ''
      },
      showError: false,
      formStep: 1,
      formCode: 0,
      isSending: false,
      form: {
        prescriptionCodes: [
          {
            number: ''
          }
        ],
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        deliveryType: '',
        isConditionsAgreement: false,
      },
      form2: {
        pharmacyId: '',
      },
      form3: {
        postCode: '',
        city: '',
        street: '',
        houseNumber: ''
      },
      pharmacies: null,
      pharmacy: ''
    }),
    mounted() {
      this.getPharmacies();
    },
    computed: {
      selectedPharmacyID() {
        return this.form2.pharmacyId
      },
      flatPrescriptionsCodes() {
        return this.form.prescriptionCodes.map(el => el.number)
      }
    },
    methods: {
      addPrescription() {
        this.form.prescriptionCodes.push({number: ''})
      },
      removePrescription() {
        this.form.prescriptionCodes.pop()
      },
      goBack(){
        this.formStep = 1;
      },
      onSubmitForm1() {

          let data = this.form;

          this.isSending = true;

          axios.post(`${API_HOST}/PrescriptionReservation/BasicInfo`, {
            prescriptionCodes: this.flatPrescriptionsCodes,
            deliveryType: data.deliveryType,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phone: data.phone
          }).then(response => {

            this.formCode = response.data.FormCode;

            if ( data.deliveryType === 'Delivery' )
            {
              // if delivery, goto step 3
              this.formStep = 3;
            }
            else
            {
              // or goto step 2
              this.formStep = 2;
            }

            this.scrollTop();

          }).catch(err => {
            console.log(err);
            this.showError = true;
          }).finally(() => {
            this.isSending = false;
          });
      },
      onSubmitForm2() {

        let data = this.form2;

        this.isSending = true;

        axios.post(`${API_HOST}/PrescriptionReservation/PickupPharmacy`, {
          formCode: this.formCode,
          pharmacyId: data.pharmacyId
        }).then(response => {
          this.success.heading = 'Rezervace léků proběhla úspěšně';
          this.success.text = 'Počkejte prosím na potvrzující email a SMS z EUC lékárny. Poté na Vás budou léky čekat ve vámi zvolené EUC lékárně.';
          this.success.show = true;

          this.scrollTop();

          // send GA
          dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Formular', 'action': 'Rezervace leku', 'label': 'Odeslan', 'value': 0 } });
        }).catch(err => {
          console.log(err);
          this.showError = true;
        }).finally(() => {
          this.isSending = false;
        });
      },
      onSubmitForm3() {

          let data = this.form3;

          this.isSending = true;

          axios.post(`${API_HOST}/PrescriptionReservation/DeliveryInfo`, {
            formCode: this.formCode,
            postCode: data.postCode,
            city: data.city,
            street: data.street,
            houseNumber: data.houseNumber
          }).then(response => {
            this.success.heading = 'Odeslání proběhlo v pořádku';
            this.success.text = 'Budeme Vás kontaktovat, abychom dohodli termín doručení léků na Vámi uvedenou adresu.';
            this.success.show = true;

            this.scrollTop();

            // send GA
            dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Formular', 'action': 'Rezervace leku', 'label': 'Odeslan', 'value': 0 } });
          }).catch(err => {
            console.log(err);
            this.showError = true;
          }).finally(() => {
            this.isSending = false;
          });
      },
      scrollTop(){
        window.scrollTo(0,0);
      },
      getPharmacies() {
        const url = `${API_HOST}/Facility/GetPharmacies`;
        axios
          .get(url)
          .then(response => {
            this.pharmacies = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      localDays(days) {
        let sortedDays = []
        let order = [1, 2, 3, 4, 5, 6, 0]
        order.map(item => {
          switch (days[item].label) {
          case 'Monday':
            days[item].label = 'Po';
            break;
          case 'Tuesday':
            days[item].label = 'Út';
            break;
          case "Wednesday":
            days[item].label = 'St';
            break;
          case 'Thursday':
            days[item].label = 'Čt';
            break;
          case 'Friday':
            days[item].label = 'Pá';
            break;
          case 'Saturday':
            days[item].label = 'So';
            break;
          case 'Sunday':
            days[item].label = 'Ne';
            break;
          default:
            break;
          }
          sortedDays.push(days[item])
        });
        return sortedDays
      },
      reloadPage(){
        window.location.reload();
      }
    },
    watch: {
      selectedPharmacyID: function (id) {
        this.pharmacy = this.pharmacies.find(item => item.id === id)
      }
    }
  })
  .mount('#prescriptionReserve');
}
